const JOB_AIDS_AGENT360 = '/training-and-job-aids/job-aids?category_ids[]=agent360';
const STATE_AVAIL_MAP = '/products/product-availability-map';

export {
    JOB_AIDS_AGENT360,
    STATE_AVAIL_MAP,
};
